import { AxiosPromise } from 'axios';
import { instance } from '../../../../services/api';

export default (contactFileId: number, groupId: number): AxiosPromise =>
    instance.get(`api/localGroupMemberDetails/${groupId}/${contactFileId}/groupMemberLinksForLocalGroup`);
